import {
  Popover as _Popover,
  UncontrolledPopover as _UncontrolledPopover,
  PopoverProps as _PopoverProps,
  UncontrolledPopoverProps as _UncontrolledPopoverProps
} from "reactstrap";

export const Popover = _Popover;
export const UncontrolledPopover = _UncontrolledPopover;

export type PopoverProps = _PopoverProps;
export type UncontrolledPopoverProps = _UncontrolledPopoverProps;
